import { FormNumber } from '@components/form';
import './AngleInput.scss';
import { defineComponent, h, PropType } from 'vue';
import { Button } from '@phi/components';

export default defineComponent({
    props: {
        min: {
            required: false,
            type: Number,
            default: 0,
        },

        max: {
            required: false,
            type: Number,
            default: 360,
        },

        value: {
            required: true,
            type: Number,
        },

        angles: {
            required: false,
            type: Array as PropType<Array<number>>,
            default: () => [0, 90, 180, 270, 360],
        },
    },

    emits: {
        'update:value': (x: number) => true,
    },

    render() {
        return h('div', { class: 'angle-input' }, [
            h(FormNumber, {
                min: this.min,
                max: this.max,
                change: true,
                value: this.value,
                'onUpdate:value': x => this.$emit('update:value', x),
            }),

            h('div', { class: 'btn-group' },
                this.angles.map(deg => h(Button, {
                    onClick: () => this.$emit('update:value', deg)
                }, () => deg.toString() + '°')),
            ),
        ]);
    }
});
